import React from 'react';

const PlacementTable = ({ data }) => {
  const getCtcClass = (ctc) => {
    if (ctc > 8) return 'ctc-high';
    if (ctc > 5) return 'ctc-medium';
    return 'ctc-low';
  };

  return (
    <div className="table-container">
      <h2 style={{ marginBottom: '20px', color: '#e2e8f0', fontSize: '2em', fontWeight: '700' }}>
        Company Details
      </h2>
      
      <table id="placementTable">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Company</th>
            <th>Type</th>
            <th>Roles</th>
            <th>CTC (LPA)</th>
            <th>Stipend</th>
            <th>Placed</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const ctcDisplay = item.ctc > 0 ? `₹${item.ctc.toFixed(2)}` : 'N/A';
            const stipendDisplay =
              item.stipend > 0 ? `₹${(item.stipend / 1000).toFixed(0)}K` : 'N/A';

            return (
              <tr key={index}>
                <td>
                  <strong>{index + 1}</strong>
                </td>
                <td>
                  <strong>{item.company}</strong>
                </td>
                <td>{item.type}</td>
                <td>{item.roles}</td>
                <td className={getCtcClass(item.ctc)}>{ctcDisplay}</td>
                <td>{stipendDisplay}</td>
                <td>
                  <strong>{item.placed}</strong>
                </td>
                <td>
                  <span className={`status-badge status-${item.status.toLowerCase()}`}>
                    {item.status}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="off-campus-note">
        <p>
          <strong>Note:</strong> The placement statistics include off-campus placements data
          secured by students.
        </p>
      </div>
    </div>
  );
};

export default PlacementTable;
